import { cn } from "@/lib/utils";

interface ProgressBarProps {
  value: number;
  max: number;
  className?: string;
  /** Fill color token; defaults to primary. Pass e.g. "bg-warning" near the limit. */
  fillClassName?: string;
}

/**
 * Small labeled usage meter for Billing. Not promoted to src/components/ui
 * because it's a single plain div pairing (track + fill) with no variants —
 * not worth a shared primitive yet.
 */
export function ProgressBar({ value, max, className, fillClassName = "bg-primary" }: ProgressBarProps) {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  return (
    <div
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn("h-2 w-full overflow-hidden rounded-full bg-muted", className)}
    >
      <div
        className={cn("h-full rounded-full transition-all duration-300 ease-out", fillClassName)}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
